/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line
import { withRouter } from 'react-router'
import { Form, Input, message, Button } from 'antd'
import LoginStyle from './style'
import LogoAICloud from '../../assets/logo_ai_cloud.png'
import SystemConfig from '../../config/loader'
import SessionService from '../../core/session'

const FormItem = Form.Item

const sessionService = SessionService.Instance()
const serverConfig = SystemConfig.loadServerConfig()

type Props = {
  history: any
  form: any
}

class Login extends Component<Props> {
  handleLogin = (e: Event) => {
    e.preventDefault()

    this.props.form.validateFields((err: any, values: any) => {
      if (err) {
        return
      }

      sessionService
        .login(values.mail, values.password)
        .then((responseData: any) => {
          if (!responseData.success) {
            message.warning(responseData.error)
          } else {
            message.success('登录成功')
            this.props.history.push('/')
          }
          return responseData
        })
        .catch((error: Error) => {
          console.log(error)
          message.warning(error.message)
        })
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    return (
      <Form onSubmit={this.handleLogin} css={LoginStyle['login-page']}>
        <div css={LoginStyle['top-bar']}>
          <a css={LoginStyle['site-avatar']} href={`//${serverConfig.host}`}>
            <img
              src={LogoAICloud}
              css={LoginStyle['logo-image']}
              alt="AI-Cloud"
            />
          </a>
        </div>

        <div css={LoginStyle['login-container']}>
          <div className="login-panel" css={LoginStyle['login-panel']}>
            <div className="login-title" css={LoginStyle['login-title']}>
              管理系统
            </div>
            <div className="login-form">
              <div css={LoginStyle['form-item']}>
                <label>Email</label>
                <FormItem
                  className="vp-form-item"
                  css={LoginStyle['form-item-input']}
                >
                  {getFieldDecorator('mail', {
                    rules: [
                      {
                        type: 'email',
                        message: '请填入正确的邮箱格式!',
                      },
                      { required: true, message: '未填写正确的邮箱' },
                    ],
                  })(
                    <Input
                      type="text"
                      css={LoginStyle['login-input']}
                      className="vp-input form-control"
                      placeholder="邮箱"
                    />
                  )}
                </FormItem>
              </div>

              <div css={LoginStyle['form-item']}>
                <label>Password</label>
                <FormItem
                  className="vp-form-item"
                  css={LoginStyle['form-item-input']}
                >
                  {getFieldDecorator('password', {
                    rules: [{ required: true, message: '未填写密码' }],
                  })(
                    <Input
                      type="password"
                      css={LoginStyle['login-input']}
                      className="vp-input form-control"
                      placeholder="密码"
                    />
                  )}
                </FormItem>
              </div>

              <FormItem className="vp-form-item last">
                <Button
                  key="submit"
                  htmlType="submit"
                  className="login-btn"
                  css={LoginStyle['login-btn']}
                  type="primary"
                >
                  登录
                </Button>
              </FormItem>
            </div>
            <div className="cutting-line" css={LoginStyle['cutting-line']}>
              做专业的
              <a href={`//${serverConfig.host}`}>人工智能云服务平台</a>
            </div>
          </div>
        </div>
      </Form>
    )
  }
}

const LoginForm = Form.create()(Login)
export default withRouter(LoginForm)
